<template>
  <div class="relative min-h-screen min-w-screen flex flex-col justify-between pb-8">
      <life-pass-tip :tipState="tipState" />
      <full-screen-map :mapViewState="fullScreenMapState" @closeMap="closeMapFun" :pass="activeMapPass" />

      <div>
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-10 mt-2 left-8 cursor-pointer" @click="navStateTrue(), this.$store.dispatch('setSearchStatus', false)"><path d="M0.523438 2.38379V0.63028H16.3051V2.38379H0.523438ZM0.523438 16.4119V14.6584H16.3051V16.4119H0.523438ZM0.523438 9.39785V7.64433H16.3051V9.39785H0.523438Z" fill="white"/></svg>
          <default-header 
              type="light"
              :title="$t('mylifepass')"
              headerClasses="bg-primary pb-12"
              textClasses="text-white"
              :masked="true"
              @filteringPasses="changeFilter"
          />
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-10 mt-1.5 right-8 cursor-pointer" v-if="!toggledSearchState" @click="searchStateTrue"><path d="M18.375 18.375L14.4497 14.4428M16.625 9.1875C16.625 11.16 15.8414 13.0518 14.4466 14.4466C13.0518 15.8414 11.16 16.625 9.1875 16.625C7.21495 16.625 5.3232 15.8414 3.92839 14.4466C2.53359 13.0518 1.75 11.16 1.75 9.1875C1.75 7.21495 2.53359 5.3232 3.92839 3.92839C5.3232 2.53359 7.21495 1.75 9.1875 1.75C11.16 1.75 13.0518 2.53359 14.4466 3.92839C15.8414 5.3232 16.625 7.21495 16.625 9.1875V9.1875Z" stroke="#F4F7FF" stroke-width="1.75" stroke-linecap="round"/></svg>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-10 mt-2 right-8 cursor-pointer" v-else @click="searchStateFalse"><path d="M0.410151 12.2938C0.243173 12.4667 0.150778 12.6982 0.152867 12.9386C0.154955 13.1789 0.25136 13.4088 0.421318 13.5788C0.591275 13.7487 0.821186 13.8451 1.06153 13.8472C1.30188 13.8493 1.53343 13.7569 1.70632 13.5899L7.00007 8.29618L12.2938 13.5908C12.3784 13.6784 12.4795 13.7482 12.5914 13.7963C12.7032 13.8443 12.8235 13.8696 12.9452 13.8707C13.0669 13.8717 13.1876 13.8485 13.3003 13.8024C13.4129 13.7563 13.5153 13.6883 13.6013 13.6022C13.6874 13.5161 13.7555 13.4138 13.8016 13.3011C13.8477 13.1885 13.8709 13.0678 13.8698 12.9461C13.8687 12.8244 13.8435 12.7041 13.7954 12.5922C13.7474 12.4804 13.6775 12.3792 13.59 12.2947L8.29623 7.00002L13.59 1.70627C13.757 1.53338 13.8494 1.30183 13.8473 1.06148C13.8452 0.821134 13.7488 0.591222 13.5788 0.421265C13.4089 0.251308 13.1789 0.154904 12.9386 0.152815C12.6983 0.150727 12.4667 0.243122 12.2938 0.410099L7.00007 5.70385L1.70632 0.4101C1.53343 0.243122 1.30188 0.150727 1.06153 0.152816C0.821186 0.154904 0.591275 0.251308 0.421317 0.421266C0.25136 0.591223 0.154955 0.821135 0.152866 1.06148C0.150778 1.30183 0.243172 1.53338 0.410151 1.70627L5.7039 7.00002L0.409234 12.2938L0.410151 12.2938Z" fill="white"/></svg>
          <pulse-loader :loading="loading" color="#223672" size="15px" class="fixed transform -translate-y-1/2 -translate-x-1/2 left-1/2 top-1/2"></pulse-loader>


          <carousel v-if="!loading" :items-to-show="1" :wrapAround="false" :touchDrag="filterPassesArr.length > 1 ? true : false" class="-mt-20 -mb-14 z-0" :class="filterPassesArr.length > 1 ? 'mlmr' : ''">
              <slide v-for="(pass, index) in filterPassesArr" :key="index" class="slide mb-1">
                  <div class="w-full px-2.5">
                      <div class="slideCard text-white rounded-3xl p-5 text-left bg-black" :style="`background-repeat: no-repeat; background-size: cover; background-image: linear-gradient(${selectedGradientColour(index + 1, pass.deviceColour, false)});`">
                          <div class="flex items-start justify-between py-1" @click="$router.push({ name: 'LifePass', params: { id: pass.deviceCode, colour: selectedGradientColour(index + 1, pass.deviceColour, false), fontColour: selectedGradientColour(index + 1, pass.deviceColour, true), passIndex: index + 1, totalPasses: filterPassesArr.length } })">
                              <img src="@/assets/images/logos/LP_White_no_text.svg" alt="lifepass logo without text." class="w-12 h-12">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="cursor-pointer h-8 w-8"><path d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z" fill="white"/><path d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z" fill="white"/><path d="M12 10C11.7348 10 11.4804 10.1054 11.2929 10.2929C11.1054 10.4804 11 10.7348 11 11V16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16V11C13 10.7348 12.8946 10.4804 12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10Z" fill="white"/></svg>
                          </div>
                          <span class="block font-sans-secondary text-4xl" @click="$router.push({ name: 'LifePass', params: { id: pass.deviceCode, colour: selectedGradientColour(index + 1, pass.deviceColour, false), fontColour: selectedGradientColour(index + 1, pass.deviceColour, true), passIndex: index + 1, totalPasses: filterPassesArr.length } })">{{ pass.deviceCode }}</span>
                          <span class="block text-lg pb-3 font-sans-secondary">
                          {{ pass.firstName && pass.lastName ? pass.firstName + ' ' + pass.lastName : ( pass.firstName ? pass.firstName : 'User name') }}
                          </span>
                          <div class="grid grid-cols-2 gap-y-5 gap-x-10 pb-0">
                              <div class="flex flex-col space-y-5 col-span-2">
                                  <div class="flex flex-col">
                                      <span class="block text-xs">{{ $t('lastupdated') }}</span>
                                      <span class="block font-sans-secondary text-lg">{{ timeAgo(pass.lastComm) }} ago</span>
                                  </div>
                              </div>
                              <div class="flex flex-col col-span-2">
                                  <span class="block text-xs">{{ $t('lifepassexpires') }}</span>
                                  <span class="block font-sans-secondary text-lg">{{ formatDate(pass.allocatedTo) }}</span>
                              </div>
                              <div class="flex space-x-10">
                                  <div class="flex flex-col">
                                      <span class="block text-xs">{{ $t('battery') }}</span>
                                      <battery-status :charge="pass.battery" />
                                  </div>
                                  <div class="flex flex-col min-w-max">
                                      <span class="block text-xs">LifePass</span>
                                      <span class="block font-sans-secondary text-lg">{{ index + 1 }} {{ $t('of') }} {{ devices.length }}</span>
                                  </div>
                                  <div class="flex flex-col min-w-max">
                                      <span class="block text-xs">Category</span>
                                      <span class="block font-sans-secondary text-lg">{{pass.consumerCategory}}</span>
                                  </div>
                                  <div class="flex flex-col min-w-max">
                                      <span class="block text-xs">Ticket Type</span>
                                      <span class="block font-sans-secondary text-lg">{{pass.productName}}</span>
                                  </div>
                              </div>

                                <default-button 
                                  @click="openMapView([pass], index)"
                                  buttonClasses="col-span-2 text-center flex items-center justify-center border border-white w-full text-white text-lg z-100"
                                  :text="$t('viewonmap')"
                                  v-if="pass.inResort"
                                  />
                                  <default-button 
                                  @click="openMapView([pass], index)"
                                  :disabled="true"
                                  buttonClasses="col-span-2 text-center flex items-center justify-center border border-white w-full text-white text-lg z-100"
                                  style="cursor: default;"
                                  :text="$t('outofarea')"
                                  v-else
                                  />
                          </div>
                      </div>
                  </div>
              </slide>
          </carousel>

          <div class="w-full z-40 relative" v-if="filterPassesArr.length > 0">
            <default-button 
            @click="openMapView(this.devices, undefined)"
            v-if="deviceLocationsAvailable"
            buttonClasses="col-span-2 mt-6 ml-auto mr-auto text-center flex items-center justify-center text-white text-lg z-40"
            style="background-color: #233772; width: 80%;"
            :text="$t('viewalllocations')"
            />
            <default-button 
            v-else
            buttonClasses="col-span-2 mt-6 ml-auto mr-auto text-center flex items-center justify-center text-white text-lg z-40"
            style="background-color: #233772; width: 80%; cursor: default;"
            :text="$t('noLocationsAvailable')"
            />
          </div>
      </div>

      <div class="relative w-full text-center align-middle m-auto" v-if="bookingReturned === true">
            <h1 class="text-lg">All Passes Returned Successfully</h1>
      </div>
  </div>
</template>
<script>
import LifePassTip from "@/components/LifePassTip.vue";
import FullScreenMap from "@/components/FullScreenMap.vue";
import { mapState } from 'vuex'
import moment from 'moment';
import DefaultHeader from "@/components/Header.vue";
import BatteryStatus from "@/components/BatteryStatus.vue";
import DefaultButton from "@/components/Button.vue";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'

export default {
  components: {
    LifePassTip,
    FullScreenMap,
    DefaultHeader,
    BatteryStatus,
    DefaultButton,
    PulseLoader,
    Carousel,
    Slide
  },
  data() {
    return {
      loading: true,
      fatMap: require('@/assets/images/logos/fatmap.png'),
      activeMapPass: null,
      fullScreenMapState: false,
      passesReturned: false,
      gradients: [
          {
            title: 'Pink',
            colour: '#E7328A',
            bgColour: '92.74deg, #AA1A61 2.45%, #E7328A 98.1%, #E7328A 98.1%',
          },
          {
            title: 'Light Blue',
            colour: '#38AAE1',
            bgColour: '92.74deg, #38AAE1 2.45%, #75CBF2 98.1%',
          },
          {
            title: 'Green',
            colour: '#16857F',
            bgColour: '92.74deg, #16857F 2.45%, #16A69D 98.1%',
          },
      ],
      options: {
        initialSlide: 0,
        navButtons: false,
        mobileFirst: true,
        slidesToShow: 1,
        renderBottomCenterControls: true,
      },
      devices: [],
      bookingReturned: false,
      deviceFilter: '',
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.token
    }),
    toggledSearchState() {
      return this.$store.state.searchStatus;
    },
    deviceLocationsAvailable(){
      for(let i=0; i<this.devices.length; i++)
      {
        if(this.devices[i].inResort)
          return true;
      }

      return false;
    },
    filterPassesArr() {
      let devicesArr = this.devices;
      if(this.deviceFilter != null && this.deviceFilter.length > 2) {
        const value = this.deviceFilter.charAt(0).toUpperCase() + this.deviceFilter.slice(1);
        return devicesArr.filter(function(device){
          return device.deviceCode.includes(value) ||
                 device.firstName && device.firstName.toUpperCase().includes(value.toUpperCase()) ||
                 device.lastName && device.lastName.toUpperCase().includes(value.toUpperCase())
        })
      }else {
        var filterDevicesArr = devicesArr.sort(function (a, b) {
          return a.deviceCode - b.deviceCode;
        });
        return filterDevicesArr;
      }
    },
    tipState() {
      if (window.localStorage.getItem('tip') != 'false') {
        return false
      } else {
        return false
      }
    }
  },
  mounted() {
    if (!window.localStorage.getItem('token')) {
      this.$router.push({ name: 'Language' });
    } else {
      this.passesReturned = localStorage.getItem('passesReturned');
      console.log(this.passesReturned)
      this.scrollToTop(); 
      this.getDevices();
      // start a timer to recall the map function every 30 seconds
      this.timer = setInterval(() => {
        this.getDevices();
      },30000)
    }
  },
  methods: {
    getDevices() {
      this.axios
        .get(`${process.env.VUE_APP_API_BASE_URL}/api/app/device`)
        .then((res) => {
          this.devices = res.devices;
          this.bookingReturned = res.bookingReturned;
          
          res.devices.forEach((device) => {
            const storedDevice = localStorage.getItem(device.deviceCode);

            if (!storedDevice) {
              localStorage.setItem(device.deviceCode, JSON.stringify({
                lat: device.latitude,
                lng: device.longitude,
              }));
            } else {
              const storedDeviceData = JSON.parse(storedDevice);

              if (device.altitude != '0.00') {
                storedDeviceData.lat = device.latitude;
                storedDeviceData.lng = device.longitude;
                localStorage.setItem(device.deviceCode, JSON.stringify(storedDeviceData));
              }
            }
          });
        }).finally(() => {
          this.loading = false;
        });
    },
    changeFilter(filter) {
      this.deviceFilter = filter;
    },
    formatDate(date) {
      return moment(date).locale(window.localStorage.getItem('selectedLangShort', name)).format('dddd, DD MMM yy');
    },
    timeAgo(date) {
      return  moment(date).locale(window.localStorage.getItem('selectedLangShort', name)).fromNow(true);
    },
    navStateTrue() {
      this.$store.dispatch('setSidebarStatus', true);
    },
    openMapView(devices, singleIndex) {
      this.fullScreenMapState = true;
      let passes = [];

      for(let i=0; i<devices.length; i++)
      {
        if(!devices[i].inResort)
          continue;

        // Get the device data from localStorage
        const storedDeviceData = JSON.parse(localStorage.getItem(devices[i].deviceCode));

        // If the device data exists in localStorage, use it. Otherwise, use the original device data.
        let deviceLocation = storedDeviceData
          ? { ...devices[i], latitude: storedDeviceData.lat, longitude: storedDeviceData.lng }
          : devices[i];

          if(singleIndex === undefined)
            deviceLocation.color = this.selectedGradientColour(i + 1, devices[i].deviceColour, true);
          else
            deviceLocation.color = this.selectedGradientColour(singleIndex + 1, devices[i].deviceColour, true);

          passes.push(deviceLocation);
      }

      this.activeMapPass = passes;
    },
    closeMapFun() {
      this.fullScreenMapState = false;

      this.activeMapPass = null;
    },
    searchStateTrue() {
      this.$store.dispatch('setSearchStatus', true);
    },
    searchStateFalse() {
      this.$store.dispatch('setSearchStatus', false);
    },
    scrollToTop() {
      window.scrollTo(0,0);
    },
    selectedGradientColour(index, badgeOption, boolean) {
      if(badgeOption != null) {
        const object = this.gradients.find(obj => obj.title === badgeOption);
        if(boolean == false) {
          return object.bgColour;
        }
        return object.colour;
      }

      if(index % 2 === 0) {
        // if boolean is false return the bgcolour else return the text colour
        if(boolean == false) {
          return this.gradients[1].bgColour;
        }
        return this.gradients[1].colour;
      }else if(index % 3 === 0) {
        // if boolean is false return the bgcolour else return the text colour
        if(boolean == false) {
          return this.gradients[2].bgColour;
        }
        return this.gradients[2].colour;
      }else {
        // if boolean is false return the bgcolour else return the text colour
        if(boolean == false) {
          return this.gradients[0].bgColour;
        }
        return this.gradients[0].colour;
      }

    }
  }
};
</script>

<style lang="scss">
  .carousel__track {
    scale: 0.85;
  }
  .carousel__slide--visible {
    transform: rotateY(0);
  }
</style>